import BasePage from '../../components/base-page/base-page';
import type { UiElement } from '../../../shared/ui-element/ui-element';
import analytics, { events } from '../../../shared/analytics';

import './family.scss';

class FamilyPage extends BasePage {
  ui = {
    ctaSection: '.js-family-cta-section',
    familyGetNowFirstButton: '.js-family-get-now-first-button',
    familyGetNowSecondButton: '.js-family-get-now-second-button',
    familyExploreAppsButton: '.js-family-explore-apps-button',
    familyTryFreeButton: '.js-family-try-free-button',
    familyTryPlanButton: '.js-family-try-plan-button',
    familyViewPlansButton: '.js-family-view-plans-button',
  };

  events = {
    'click @ui.familyGetNowFirstButton': 'handleFamilyGetNowFirstButton',
    'click @ui.familyGetNowSecondButton': 'handleFamilyGetNowSecondButton',
    'click @ui.familyExploreAppsButton': 'handleFamilyExploreAppsButton',
    'click @ui.familyTryFreeButton': 'handleFamilyTryFreeButton',
    'click @ui.familyTryPlanButton': 'handleFamilyTryPlanButton',
    'click @ui.familyViewPlansButton': 'handleFamilyViewPlansButton',
  };

  onInit() {
    super.onInit();

    if ('IntersectionObserver' in window) {
      const ctaSection = this.ui.ctaSection as UiElement;
      ctaSection.classList.add('cta-section_shifted');

      const ctaSectionObserver = new IntersectionObserver(this.handleCtaSectionIntersection);
      ctaSectionObserver.observe(ctaSection);
    }
  }

  handleCtaSectionIntersection = (entries) => {
    entries.forEach((entry) => {
      (this.ui.ctaSection as UiElement).classList.toggle('cta-section_shifted', !entry.isIntersecting);
    });
  };

  handleFamilyGetNowFirstButton = () => analytics.trackEvent({
    ...events.FAMILY_LANDING_GET_NOW_CLICK,
    eventLabel: '1',
  });

  handleFamilyGetNowSecondButton = () => analytics.trackEvent({
    ...events.FAMILY_LANDING_GET_NOW_CLICK,
    eventLabel: '2',
  });

  handleFamilyExploreAppsButton = () => analytics.trackEvent(events.FAMILY_LANDING_EXPLORE_APPS_CLICK);

  handleFamilyTryFreeButton = () => analytics.trackEvent(events.FAMILY_LANDING_TRY_FREE_CLICK);

  handleFamilyTryPlanButton = () => analytics.trackEvent(events.FAMILY_LANDING_TRY_PLAN_CLICK);

  handleFamilyViewPlansButton = () => analytics.trackEvent(events.FAMILY_LANDING_VIEW_PLANS_CLICK);
}

export default FamilyPage;

(FamilyPage as UiElement).initOnDomLoaded();
